<clr-progress-bar [clrValue]="percent" clrMax="100" [clrColor]="color()"></clr-progress-bar>
<span>Submission Status: {{label}}</span>
<div *ngIf="displayDetails" class="status-details">
  <p>Reason: {{details}}</p>
  <button *ngIf="displayButton" class="btn btn-action" name="{{buttonText}}" (click)="emitActionBtnClick()">
    {{buttonText}}</button>
</div>
